export default "__VITE_ASSET__C6qCiV99__"